import { useMemo } from 'react'
import { v4 } from 'uuid'

/**
 * Just a simple hook to generate a unique id
 */
export const useId = () => {
  return useMemo(() => v4(), [])
}
